import { FC, ReactNode, useEffect, useRef } from 'react';
import CloseIcon from '@material-ui/icons/Close';
import './FloatingActionBar.scss';

type FloatingActionBarProps = {
  count: number;
  countLabel: string;
  onClose: () => void;
  children: ReactNode;
};

const FloatingActionBar: FC<FloatingActionBarProps> = ({ count, countLabel, onClose, children }) => {
  const barRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const bar = barRef.current;
    if (!bar || count === 0) return;

    const content = document.querySelector('.scrollable-content');
    if (!content) return;

    const updatePosition = () => {
      const rect = content.getBoundingClientRect();
      const center = rect.left + rect.width / 2;
      bar.style.left = `${center}px`;
      bar.style.transform = 'translateX(-50%)';
    };

    requestAnimationFrame(updatePosition);
    const observer = new ResizeObserver(updatePosition);
    observer.observe(content);
    return () => observer.disconnect();
  }, [count]);

  if (count === 0) return null;

  return (
    <div className="floating-action-bar" ref={barRef}>
      <button className="floating-action-bar__action" onClick={onClose} style={{ padding: '6px 8px' }}>
        <CloseIcon style={{ fontSize: 16 }} />
      </button>
      <span className="floating-action-bar__count">
        {count} {countLabel}
      </span>
      <div className="floating-action-bar__divider" />
      {children}
    </div>
  );
};

export default FloatingActionBar;

export const FloatingActionBarButton: FC<{
  icon: ReactNode;
  label: string;
  onClick: () => void;
}> = ({ icon, label, onClick }) => (
  <button className="floating-action-bar__action" onClick={onClick}>
    {icon}
    {label}
  </button>
);

export const FloatingActionBarDivider: FC = () => (
  <div className="floating-action-bar__divider" />
);
